import { useQuery } from '@tanstack/react-query';

import { SkyMapAxiosServiceFactory } from '../../../../services/axios/skymap-axios-service-factory';

export const useFetchGcpCorrectionJobQuery = (geodataId: string, enabled = true) => {
  const query = useQuery({
    queryKey: ['fetchGcpCorrectionJob', geodataId],
    queryFn: async () => {
      try {
        const response = await SkyMapAxiosServiceFactory.instance
          .createGeodataServiceV0()
          .fetchGcpCorrectionJob({
            path: { geodataId },
          });
        return response.data;
      } catch (error: any) {
        // If the job doesn't exist (404), return undefined instead of throwing
        if (error?.response?.status === 404) {
          return undefined;
        }
        throw error;
      }
    },
    enabled,
    refetchOnWindowFocus: false,
    retry: false,
  });

  return {
    gcpCorrectionJobRequest: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
